import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Video, Users, Settings, Calendar } from 'lucide-react';

const SettingsSection = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-500">Configure your academy</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
        <button 
          onClick={() => navigate('/admin/content?tab=welcome-video')}
          className="bg-white rounded-xl border p-6 text-left hover:shadow-md transition-shadow"
        >
          <Video className="w-10 h-10 text-orange-600 mb-4" />
          <h3 className="font-semibold text-lg mb-2">Welcome Video</h3>
          <p className="text-gray-500 text-sm">Set the intro video for new students</p>
        </button>
        
        <button 
          onClick={() => navigate('/admin/user-access')}
          className="bg-white rounded-xl border p-6 text-left hover:shadow-md transition-shadow"
        >
          <Users className="w-10 h-10 text-blue-600 mb-4" />
          <h3 className="font-semibold text-lg mb-2">User Access Management</h3>
          <p className="text-gray-500 text-sm">Grant or revoke user access</p>
        </button>
        
        <button 
          onClick={() => navigate('/settings')}
          className="bg-white rounded-xl border p-6 text-left hover:shadow-md transition-shadow"
        >
          <Settings className="w-10 h-10 text-gray-600 mb-4" />
          <h3 className="font-semibold text-lg mb-2">Account Settings</h3>
          <p className="text-gray-500 text-sm">Manage your profile and preferences</p>
        </button>
        
        <button 
          onClick={() => navigate('/live-sessions')}
          className="bg-white rounded-xl border p-6 text-left hover:shadow-md transition-shadow"
        >
          <Calendar className="w-10 h-10 text-green-600 mb-4" />
          <h3 className="font-semibold text-lg mb-2">Live Sessions</h3>
          <p className="text-gray-500 text-sm">Schedule and manage Zoom sessions</p>
        </button>
      </div>
    </div>
  );
};

export default SettingsSection;
